<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form (ngSubmit)="search()">
      <div class="filter-form__header sticky">
        <hw-button display="secondary" (click)="emptyFilter()">
          {{ 'integration.econ-01.filter.reset' | translate }}
        </hw-button>
        <hw-button class="float-right" [disabled]="loading" type="submit">
          {{ 'integration.econ-01.filter.search' | translate }}
        </hw-button>
      </div>
      <div class="filter-form__body">
        <hw-panel-form-item label="integration.econ-01.filter.speciality">
          <hw-term-codesystem-concept-select
            name="speciality"
            [(ngModel)]="speciality"
            display="codeName"
            valueType="primitive"
            codesystem="speciality">
          </hw-term-codesystem-concept-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.econ-01.filter.created-from">
          <hw-date-time-picker name="from" [(ngModel)]="params.validFrom"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.econ-01.filter.created-to">
          <hw-date-time-picker name="to" [(ngModel)]="params.validTo"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="integration.econ-01.filter.status">
          <hw-term-codesystem-concept-select
            display="name"
            name="request-status"
            [codesystem]="'request-status'"
            [filter]="onlyTis"
            [(ngModel)]="params.status">
          </hw-term-codesystem-concept-select>
        </hw-panel-form-item>
      </div>
    </form>
  </div>

  <nz-content class="page-content--header-inside">
    <hw-page-header header="integration.econ-01.header" class="page-header"></hw-page-header>

    <div class="page-content__flex-cols-container">
      <div nz-col nzSpan="24">
        <hw-spinner verticalPosition="middle" *ngIf="loading" [loading]="loading"></hw-spinner>
        <hw-table class="table-no-header" *ngIf="!loading">
          <nz-table #nzTable [nzData]="referrals" nzSize="default" nzShowPagination="false" nzPageSize="1000">
            <thead>
              <tr>
                <th>{{ 'integration.econ-01.data.id' | translate }}</th>
                <th>{{ 'integration.econ-01.data.patient' | translate }}</th>
                <th>{{ 'integration.econ-01.data.speciality' | translate }}</th>
                <th>{{ 'integration.econ-01.data.valid' | translate }}</th>
                <th>{{ 'integration.econ-01.data.referrer' | translate }}</th>
                <th>{{ 'integration.econ-01.data.referrer-org' | translate }}</th>
                <th>{{ 'integration.econ-01.data.status' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-referral [ngForOf]="nzTable.data">
                <tr>
                  <td>
                    <a (click)="openDocument(referral)">{{ referral.identifier.value }}</a>
                  </td>
                  <td>{{ referral.subject?.name['def'].text }} ({{ referral.subject?.identifiers[0].value }})</td>
                  <td>{{ referral.performer.practitioner?.speciality?.code }}</td>
                  <td>
                    {{ referral.occurrencePeriod.start | localDate }} - {{ referral.occurrencePeriod.end | localDate }}
                  </td>
                  <td>
                    {{ referral.requester.practitioner?.display }} ({{
                      referral.requester.practitioner?.identifier?.value
                    }})
                  </td>
                  <td>
                    {{ referral.requester.organization?.display }} ({{
                      referral.requester.organization?.identifier?.value
                    }})
                  </td>
                  <td>{{ referral.status?.names | localName }}</td>
                  <td>
                    <hw-button
                      (click)="respond(referral)"
                      [loading]="saveInProgress"
                      *ngIf="referral.status?.code === 'active'"
                      >{{ 'integration.econ-01.btn-respond' | translate }}</hw-button
                    >
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </nz-table>
        </hw-table>
      </div>
    </div>
  </nz-content>
</div>
